import { ReactNode } from "react";
import { RiFireLine, RiUserAddLine } from "react-icons/ri";
import Screen from "../../components/Screen";

interface NpAskProps {
  /** 問句（傳單·有指定會帶入指定瓦斯行名） */
  title?: ReactNode;
  subtitle?: ReactNode;
  onYes: () => void;
  onNo: () => void;
  /** 省略＝這一頁沒有上一步（流程第一頁）→ 不顯示返回鍵。由 Onboarding 的導航堆疊 canGoBack 決定。 */
  onBack?: () => void;
}

const btnCls =
  "flex-1 h-[130px] rounded-[16px] border-[1.5px] border-[#BFDBFE] bg-white cursor-pointer transition-colors active:bg-[#EFF6FF] active:border-[#2196f3] flex flex-col items-center justify-center gap-2.5 text-[#1565C0]";

/** 傳單・無指定瓦斯行：手機比對不到 → 問是否叫過桶裝瓦斯（並排兩顆，含圖示）。 */
const NpAsk = ({ title = "您有叫過桶裝瓦斯嗎？", subtitle = "幫您找出所屬的瓦斯行", onYes, onNo, onBack }: NpAskProps) => (
  <Screen title={title} subtitle={subtitle} onBack={onBack}>
    <div className="flex gap-2.5">
      <button onClick={onYes} className={btnCls}>
        <RiFireLine size={34} className="text-[#2196f3]" />
        <span className="font-extrabold text-[17px]">有，叫過</span>
      </button>
      <button onClick={onNo} className={btnCls}>
        <RiUserAddLine size={34} className="text-[#2196f3]" />
        <span className="font-extrabold text-[17px]">沒有，第一次</span>
      </button>
    </div>
  </Screen>
);

export default NpAsk;
